import { render, staticRenderFns } from "./MyCustomCheckbox.vue?vue&type=template&id=327ed6eb&scoped=true"
import script from "./MyCustomCheckbox.vue?vue&type=script&lang=js"
export * from "./MyCustomCheckbox.vue?vue&type=script&lang=js"
import style0 from "./MyCustomCheckbox.vue?vue&type=style&index=0&id=327ed6eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327ed6eb",
  null
  
)

export default component.exports